module.exports = __webpack_public_path__ + "static/img/2-1.a95054a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2-1.jpg
// module id = UadO
// module chunks = 0